__webpack_require__.p = "/dev/933-generate-the-blc-structure-from-labels-in-a-dez/";